import * as React from "react";
import { ActionIconTileDemo } from "../demos/ActionIconTile.demo";
import { AlertDemo } from "../demos/Alert.demo";
import { MotionPrimitivesDemo } from "../demos/MotionPrimitives.demo";
import { MarkdownDemo } from "../demos/Markdown.demo";
import { AlertDialogDemo } from "../demos/AlertDialog.demo";
import { AspectRatioDemo } from "../demos/AspectRatio.demo";
import { BreadcrumbDemo } from "../demos/Breadcrumb.demo";
import { ButtonDemo } from "../demos/Button.demo";
import { KeycapButtonDemo } from "../demos/KeycapButton.demo";
import { NotchedInputDemo } from "../demos/NotchedInput.demo";
import { NotchTextareaDemo } from "../demos/NotchTextarea.demo";
import { NotchPanelDemo } from "../demos/NotchPanel.demo";
import { NotchSegmentedDemo } from "../demos/NotchSegmented.demo";
import { NotchShowcaseDemo } from "../demos/NotchShowcase.demo";
import { CheckboxDemo } from "../demos/Checkbox.demo";
import { CollapsibleDemo } from "../demos/Collapsible.demo";
import { ContextMenuDemo } from "../demos/ContextMenu.demo";
import { DialogDemo } from "../demos/Dialog.demo";
import { HoverCardDemo } from "../demos/HoverCard.demo";
import { InputDemo } from "../demos/Input.demo";
import { PasswordInputDemo } from "../demos/PasswordInput.demo";
import { LabelDemo } from "../demos/Label.demo";
import { MenubarDemo } from "../demos/Menubar.demo";
import { PaginationDemo } from "../demos/Pagination.demo";
import { PopoverDemo } from "../demos/Popover.demo";
import { ProgressDemo } from "../demos/Progress.demo";
import { RadioGroupDemo } from "../demos/RadioGroup.demo";
import { ScrollAreaDemo } from "../demos/ScrollArea.demo";
import { SelectDemo } from "../demos/Select.demo";
import { SeparatorDemo } from "../demos/Separator.demo";
import { SheetDemo } from "../demos/Sheet.demo";
import { SliderDemo } from "../demos/Slider.demo";
import { SwitchDemo } from "../demos/Switch.demo";
import { TableDemo } from "../demos/Table.demo";
import { TabsDemo } from "../demos/Tabs.demo";
import { TextareaDemo } from "../demos/Textarea.demo";
import { ToggleDemo } from "../demos/Toggle.demo";
import { ToggleGroupDemo } from "../demos/ToggleGroup.demo";
import { AIResponseBlockDemo } from "../demos/AIResponseBlock.demo";
import { ExperienceStateBadgeDemo } from "../demos/ExperienceStateBadge.demo";
import { ArtifactTileDemo } from "../demos/ArtifactTile.demo";
import { ArtifactFocusDemo } from "../demos/ArtifactFocus.demo";
import { StatusExpressionDemo } from "../demos/StatusExpression.demo";
import { OnyxHexMaterialDemo } from "../demos/OnyxHexMaterial.demo";
import { GlassSurfaceDemo } from "../demos/GlassSurface.demo";
import { FlickeringGridDemo } from "../demos/FlickeringGrid.demo";
import { FlowButtonDemo } from "../demos/FlowButton.demo";
import { GenerationTimelineDemo } from "../demos/GenerationTimeline.demo";
import { ComponentStatesDemo } from "../demos/ComponentStates.demo";
import { TranscriptFurnitureDemo } from "../demos/TranscriptFurniture.demo";
import { ShimmerButtonDemo } from "../demos/ShimmerButton.demo";
import { AnimatedExperienceTypeIconDemo } from "../demos/AnimatedExperienceTypeIcon.demo";
import { TagInputDemo } from "../demos/TagInput.demo";
import { ChartDemo } from "../demos/Chart.demo";
import { DataTableDemo } from "../demos/DataTable.demo";
import { StatDemo } from "../demos/Stat.demo";
import { CitationDemo } from "../demos/Citation.demo";
import { CodeBlockDemo } from "../demos/CodeBlock.demo";
import { ArtifactBlockDemo } from "../demos/ArtifactBlock.demo";
import { CalloutDemo } from "../demos/Callout.demo";
import { MediaDemo } from "../demos/Media.demo";
import { KeyValueDemo } from "../demos/KeyValue.demo";
import { CarouselDemo } from "../demos/Carousel.demo";
import { ReasoningDemo } from "../demos/Reasoning.demo";
import { StepsDemo } from "../demos/Steps.demo";
import { SuggestionsDemo } from "../demos/Suggestions.demo";
import { InteractiveBlocksDemo } from "../demos/InteractiveBlocks.demo";
import { MemorySaveDemo } from "../demos/MemorySave.demo";
import { SignalBlocksDemo } from "../demos/SignalBlocks.demo";
import { BlockRendererDemo } from "../demos/BlockRenderer.demo";
import { ChatCitationsDemo } from "../demos/ChatCitations.demo";
import { IconsDemo } from "../demos/Icons.demo";
import { AuthShellDemo } from "../demos/AuthShell.demo";
import { OAuthProviderButtonsDemo } from "../demos/OAuthProviderButtons.demo";
import { EmailChipInputDemo } from "../demos/EmailChipInput.demo";
import { AvailabilityInputDemo } from "../demos/AvailabilityInput.demo";
import { SuccessStateDemo } from "../demos/SuccessState.demo";
import { FormFieldDemo } from "../demos/FormField.demo";
import { WorkspaceTransitionOverlayDemo } from "../demos/WorkspaceTransitionOverlay.demo";
import { MemberPickerDemo } from "../demos/MemberPicker.demo";
import { ColorPickerDemo } from "../demos/ColorPicker.demo";
import { AikoTourDemo } from "../demos/AikoTour.demo";
import { SetupChecklistDemo } from "../demos/SetupChecklist.demo";
import { ProgressivePollingDemo } from "../demos/ProgressivePolling.demo";
import { FilterBarDemo } from "../demos/FilterBar.demo";
import { SmartPaginationDemo } from "../demos/SmartPagination.demo";
import { ImageUploaderDemo } from "../demos/ImageUploader.demo";
import { PermissionWrapperDemo } from "../demos/PermissionWrapper.demo";
import { SourceIngestionDemo } from "../demos/SourceIngestion.demo";
import { AttributionChipDemo } from "../demos/AttributionChip.demo";
import { RedlineSpanDemo } from "../demos/RedlineSpan.demo";
import { CommentPopoverDemo } from "../demos/CommentPopover.demo";
import { DiffRowDemo } from "../demos/DiffRow.demo";
import { AppShellDemo } from "../demos/AppShell.demo";
import { MoodLightingDemo } from "../demos/MoodLighting.demo";
import { TypographySpecimenDemo } from "../demos/TypographySpecimen.demo";
// Wave-1 — primitives + components (v1.6.0)
import { ElasticSliderDemo } from "../demos/ElasticSlider.demo";
import { RailNavButtonDemo } from "../demos/RailNavButton.demo";
import { CardGridDemo } from "../demos/CardGrid.demo";
import { ExperienceCardDensityDemo } from "../demos/ExperienceCardDensity.demo";
import { OptionFieldDemo } from "../demos/OptionField.demo";
import { VaultMorphDemo } from "../demos/VaultMorph.demo";
import { MessageFeedbackDemo } from "../demos/MessageFeedback.demo";
import { FileOverlayDemo } from "../demos/FileOverlay.demo";
import { ListeningOverlayDemo } from "../demos/ListeningOverlay.demo";
import { MagicEditButtonDemo } from "../demos/MagicEditButton.demo";
import { NavRailDemo } from "../demos/NavRail.demo";
// Onyx offset-key wave — Stream A button restyles (new demos)
import { IconButtonDemo } from "../demos/IconButton.demo";
import { ThemeToggleButtonDemo } from "../demos/ThemeToggleButton.demo";
import { MicButtonDemo } from "../demos/MicButton.demo";
import { ScrollToBottomButtonDemo } from "../demos/ScrollToBottomButton.demo";
import { MessageRetryDemo } from "../demos/MessageRetry.demo";
// Onyx offset-key wave — clickable cards keep the notch (new demos)
import { CardDemo } from "../demos/Card.demo";
import { CollectionCardDemo } from "../demos/CollectionCard.demo";
import { StudioCardDemo } from "../demos/StudioCard.demo";
import { ToolCardDemo } from "../demos/ToolCard.demo";
import { SpotlightCardDemo } from "../demos/SpotlightCard.demo";
import { DepthCardDemo } from "../demos/DepthCard.demo";
import { BrandTileDemo } from "../demos/BrandTile.demo";
// atlas-wow wave (v1.11.0) — rotating usage tips for chat wait states
import { RotatingHintsDemo } from "../demos/RotatingHints.demo";

/**
 * Architectural layer a component belongs to. Mirrors the library's own
 * three-layer source layout (see `aisquare-ui/src/index.ts`):
 *
 *   stock      → src/ui/         byte-for-byte shadcn, re-exported as-is
 *   primitive  → src/primitives/ brand-flavored shadcn wrappers + net-new
 *   component  → src/components/  composed, aisquare-original (ported from pretty)
 *
 * This is the "shadcn ↔ aisquare integration" axis: how far a component
 * sits from upstream shadcn. It drives the nav grouping and the source
 * badge on each section.
 */
export type Layer = "stock" | "primitive" | "component";

/**
 * Every library version a component has been introduced in, oldest first.
 *
 * Ordered, because `LATEST_VERSION` — which drives the "New" tag — is derived
 * from the last entry rather than written out a second time. Restating it by
 * hand is what let the two drift apart: the tag was pinned at v1.12.0 while
 * v1.16.0 entries had already landed, so the newest components showed no "New"
 * badge and the previous wave kept one. Adding a version here is now the whole
 * change.
 */
export const VERSIONS = [
  "v0.1.0",
  "v0.2.0",
  "v1.1.0",
  "v1.2.0",
  "v1.3.0",
  "v1.4.0",
  "v1.5.0",
  "v1.6.0",
  "v1.7.0",
  "v1.8.0",
  "v1.11.0",
  "v1.12.0",
  "v1.16.0",
  "v1.20.0",
] as const;

/** Library version a component was introduced in — drives the "New" tag. */
export type Since = (typeof VERSIONS)[number];

export interface DemoEntry {
  id: string;
  title: string;
  layer: Layer;
  /** Functional sub-group within the layer (Overlays, Forms, AI, …). */
  category: string;
  since: Since;
  Demo: React.ComponentType;
  /**
   * Export names for the page's copyable import line. Only needed where the
   * title is not itself the export — a showcase page ("Onyx Hex material"), or
   * a title that qualifies the component ("ExperienceCard density"). Otherwise
   * the title IS the export and this is derived; see `importNamesFor`.
   */
  imports?: readonly string[];
}

export interface LayerMeta {
  id: Layer;
  /** Sidebar + main-content section heading. */
  label: string;
  /** Short word stamped on each component's badge. */
  badge: string;
  /** One-liner describing what the layer is. */
  blurb: string;
  /** Tailwind border/bg/text classes for the badge. */
  badgeClass: string;
  /** Import path a consumer uses to pull these in. */
  importPath: string;
}

/**
 * Layer definitions, in nav order: closest-to-upstream first, most
 * aisquare-original last. `badgeClass` keys the three layers to a stable
 * color so the badge reads the same in the nav and on every section.
 */
export const LAYERS: LayerMeta[] = [
  {
    id: "stock",
    label: "Stock · shadcn",
    badge: "shadcn",
    blurb:
      "Byte-for-byte shadcn/ui primitives, re-exported untouched until a brand wrapper lands. Always reachable via @aisquare/ui/stock.",
    badgeClass: "border-border bg-muted text-muted-foreground",
    importPath: "@aisquare/ui",
  },
  {
    id: "primitive",
    label: "Primitives · brand",
    badge: "brand",
    blurb:
      "Brand-flavored wrappers of shadcn primitives — same API surface, aisquare styling, motion, and defaults layered on top.",
    badgeClass: "border-primary/30 bg-primary/10 text-primary",
    importPath: "@aisquare/ui",
  },
  {
    id: "component",
    label: "Components · aisquare",
    badge: "aisquare",
    blurb:
      "Composed, aisquare-original components ported from pretty — higher-level patterns built for Creator Studio surfaces.",
    badgeClass: "border-accent/30 bg-accent/10 text-accent",
    importPath: "@aisquare/ui",
  },
];

/**
 * Every primitive demo, ordered by layer → functional category → name.
 * The order here is the order the sections render down the page, so it
 * matches the sidebar top-to-bottom.
 */
export const DEMOS: DemoEntry[] = [
  // ── Stock · shadcn ───────────────────────────────────────────────
  // Overlays
  {
    id: "alert-dialog",
    title: "AlertDialog",
    layer: "stock",
    category: "Overlays",
    since: "v0.1.0",
    Demo: AlertDialogDemo,
  },
  {
    id: "context-menu",
    title: "ContextMenu",
    layer: "stock",
    category: "Overlays",
    since: "v0.2.0",
    Demo: ContextMenuDemo,
  },
  {
    id: "dialog",
    title: "Dialog",
    layer: "stock",
    category: "Overlays",
    since: "v0.1.0",
    Demo: DialogDemo,
  },
  {
    id: "hover-card",
    title: "HoverCard",
    layer: "stock",
    category: "Overlays",
    since: "v0.2.0",
    Demo: HoverCardDemo,
  },
  {
    id: "menubar",
    title: "Menubar",
    layer: "stock",
    category: "Overlays",
    since: "v0.2.0",
    Demo: MenubarDemo,
  },
  {
    id: "popover",
    title: "Popover",
    layer: "stock",
    category: "Overlays",
    since: "v0.2.0",
    Demo: PopoverDemo,
  },
  {
    id: "sheet",
    title: "Sheet",
    layer: "stock",
    category: "Overlays",
    since: "v0.1.0",
    Demo: SheetDemo,
  },
  // Forms
  {
    id: "radio-group",
    title: "RadioGroup",
    layer: "stock",
    category: "Forms",
    since: "v0.1.0",
    Demo: RadioGroupDemo,
  },
  {
    id: "select",
    title: "Select",
    layer: "stock",
    category: "Forms",
    since: "v0.1.0",
    Demo: SelectDemo,
  },
  {
    id: "slider",
    title: "Slider",
    layer: "stock",
    category: "Forms",
    since: "v0.1.0",
    Demo: SliderDemo,
  },
  {
    id: "toggle",
    title: "Toggle",
    layer: "stock",
    category: "Forms",
    since: "v0.2.0",
    Demo: ToggleDemo,
  },
  {
    id: "toggle-group",
    title: "ToggleGroup",
    layer: "stock",
    category: "Forms",
    since: "v0.2.0",
    Demo: ToggleGroupDemo,
  },
  // Navigation
  {
    id: "breadcrumb",
    title: "Breadcrumb",
    layer: "stock",
    category: "Navigation",
    since: "v0.2.0",
    Demo: BreadcrumbDemo,
  },
  {
    id: "pagination",
    title: "Pagination",
    layer: "stock",
    category: "Navigation",
    since: "v0.2.0",
    Demo: PaginationDemo,
  },
  {
    id: "tabs",
    title: "Tabs",
    layer: "stock",
    category: "Navigation",
    since: "v0.2.0",
    Demo: TabsDemo,
  },
  // Feedback
  {
    id: "alert",
    title: "Alert",
    layer: "stock",
    category: "Feedback",
    since: "v0.1.0",
    Demo: AlertDemo,
  },
  {
    id: "motion-primitives",
    title: "AnimatedSeparator + Collapse",
    layer: "primitive",
    category: "Primitives",
    since: "v1.16.0",
    Demo: MotionPrimitivesDemo,
  },
  {
    id: "action-icon-tile",
    title: "ActionIconTile",
    layer: "primitive",
    category: "Primitives",
    since: "v1.16.0",
    Demo: ActionIconTileDemo,
  },
  {
    id: "markdown",
    title: "Markdown",
    layer: "component",
    category: "Chat surface",
    since: "v1.16.0",
    Demo: MarkdownDemo,
  },
  {
    id: "progress",
    title: "Progress",
    layer: "stock",
    category: "Feedback",
    since: "v0.2.0",
    Demo: ProgressDemo,
  },
  // Layout & Data
  {
    id: "aspect-ratio",
    title: "AspectRatio",
    layer: "stock",
    category: "Layout & Data",
    since: "v0.2.0",
    Demo: AspectRatioDemo,
  },
  {
    id: "collapsible",
    title: "Collapsible",
    layer: "stock",
    category: "Layout & Data",
    since: "v0.2.0",
    Demo: CollapsibleDemo,
  },
  {
    id: "scroll-area",
    title: "ScrollArea",
    layer: "stock",
    category: "Layout & Data",
    since: "v0.2.0",
    Demo: ScrollAreaDemo,
  },
  {
    id: "table",
    title: "Table",
    layer: "stock",
    category: "Layout & Data",
    since: "v0.1.0",
    Demo: TableDemo,
  },

  // ── Primitives · brand ───────────────────────────────────────────
  // Foundations
  {
    id: "typography-specimen",
    title: "TypographySpecimen",
    layer: "primitive",
    category: "Foundations",
    since: "v1.6.0",
    Demo: TypographySpecimenDemo,
  },
  {
    id: "icons",
    title: "Icons",
    layer: "primitive",
    category: "Foundations",
    since: "v1.4.0",
    Demo: IconsDemo,
  },
  {
    id: "button",
    title: "Button",
    layer: "primitive",
    category: "Primitives",
    since: "v0.1.0",
    Demo: ButtonDemo,
  },
  {
    id: "icon-button",
    title: "IconButton",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: IconButtonDemo,
  },
  {
    id: "theme-toggle-button",
    title: "ThemeToggleButton",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: ThemeToggleButtonDemo,
  },
  {
    id: "keycap-button",
    title: "KeycapButton",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: KeycapButtonDemo,
  },
  {
    id: "notched-input",
    title: "NotchedInput",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: NotchedInputDemo,
  },
  {
    id: "notch-textarea",
    title: "NotchTextarea",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: NotchTextareaDemo,
  },
  {
    id: "notch-panel",
    title: "NotchPanel",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: NotchPanelDemo,
  },
  {
    id: "notch-segmented",
    title: "NotchSegmented",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: NotchSegmentedDemo,
  },
  {
    id: "notch-showcase",
    title: "Notch language — composed",
    layer: "primitive",
    category: "Primitives",
    since: "v1.7.0",
    Demo: NotchShowcaseDemo,
    imports: ["NotchPanel", "NotchSegmented", "NotchedInput", "KeycapButton"],
  },
  {
    id: "checkbox",
    title: "Checkbox",
    layer: "primitive",
    category: "Primitives",
    since: "v0.1.0",
    Demo: CheckboxDemo,
  },
  {
    id: "input",
    title: "Input",
    layer: "primitive",
    category: "Primitives",
    since: "v0.2.0",
    Demo: InputDemo,
  },
  {
    id: "password-input",
    title: "PasswordInput",
    layer: "primitive",
    category: "Primitives",
    since: "v1.4.0",
    Demo: PasswordInputDemo,
  },
  {
    id: "label",
    title: "Label",
    layer: "primitive",
    category: "Primitives",
    since: "v0.1.0",
    Demo: LabelDemo,
  },
  {
    id: "separator",
    title: "Separator",
    layer: "primitive",
    category: "Primitives",
    since: "v0.1.0",
    Demo: SeparatorDemo,
  },
  {
    id: "switch",
    title: "Switch",
    layer: "primitive",
    category: "Primitives",
    since: "v0.1.0",
    Demo: SwitchDemo,
  },
  {
    id: "textarea",
    title: "Textarea",
    layer: "primitive",
    category: "Primitives",
    since: "v0.2.0",
    Demo: TextareaDemo,
  },
  // Layout - the experience-OS app frame
  {
    id: "app-shell",
    title: "AppShell",
    layer: "primitive",
    category: "Layout",
    since: "v1.6.0",
    Demo: AppShellDemo,
  },
  {
    id: "elastic-slider",
    title: "ElasticSlider",
    layer: "primitive",
    category: "Primitives",
    since: "v1.6.0",
    Demo: ElasticSliderDemo,
  },
  // Collaboration & review - inline attribution + tracked-changes marks
  {
    id: "attribution-chip",
    title: "AttributionChip",
    layer: "primitive",
    category: "Collaboration",
    since: "v1.5.0",
    Demo: AttributionChipDemo,
  },
  {
    id: "redline-span",
    title: "RedlineSpan",
    layer: "primitive",
    category: "Review & diff",
    since: "v1.5.0",
    Demo: RedlineSpanDemo,
  },

  // ── Components · aisquare ─────────────────────────────────────────
  // AI
  {
    id: "ai-response-block",
    title: "AIResponseBlock",
    layer: "component",
    category: "AI",
    since: "v1.1.0",
    Demo: AIResponseBlockDemo,
  },
  {
    id: "generation-timeline",
    title: "GenerationTimeline",
    layer: "component",
    category: "AI",
    since: "v1.1.0",
    Demo: GenerationTimelineDemo,
  },
  {
    id: "scroll-to-bottom-button",
    title: "ScrollToBottomButton",
    layer: "component",
    category: "AI",
    since: "v1.7.0",
    Demo: ScrollToBottomButtonDemo,
  },
  {
    id: "message-retry",
    title: "MessageRetry",
    layer: "component",
    category: "AI",
    since: "v1.7.0",
    Demo: MessageRetryDemo,
  },
  // Motion & Effects
  {
    id: "flickering-grid",
    title: "FlickeringGrid",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.1.0",
    Demo: FlickeringGridDemo,
  },
  {
    id: "flow-button",
    title: "FlowButton",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.1.0",
    Demo: FlowButtonDemo,
  },
  {
    id: "shimmer-button",
    title: "ShimmerButton",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.1.0",
    Demo: ShimmerButtonDemo,
  },
  {
    id: "animated-experience-type-icon",
    title: "AnimatedExperienceTypeIcon",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.3.0",
    Demo: AnimatedExperienceTypeIconDemo,
  },
  {
    id: "mood-lighting",
    title: "MoodLighting",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.6.0",
    Demo: MoodLightingDemo,
  },
  {
    id: "rotating-hints",
    title: "RotatingHints",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.11.0",
    Demo: RotatingHintsDemo,
  },
  // Inputs
  {
    id: "tag-input",
    title: "TagInput",
    layer: "component",
    category: "Inputs",
    since: "v1.1.0",
    Demo: TagInputDemo,
  },
  {
    id: "mic-button",
    title: "MicButton",
    layer: "component",
    category: "Inputs",
    since: "v1.7.0",
    Demo: MicButtonDemo,
  },
  // Status
  {
    id: "experience-state-badge",
    title: "ExperienceStateBadge",
    layer: "component",
    category: "Status",
    since: "v1.1.0",
    Demo: ExperienceStateBadgeDemo,
  },
  {
    id: "artifact-tile",
    title: "ArtifactTile",
    layer: "component",
    category: "Cards",
    since: "v1.5.0",
    Demo: ArtifactTileDemo,
  },
  {
    id: "artifact-focus",
    title: "ArtifactFocus",
    layer: "component",
    category: "Cards",
    since: "v1.5.0",
    Demo: ArtifactFocusDemo,
  },
  {
    id: "status-expression",
    title: "StatusExpression",
    layer: "component",
    category: "Status",
    since: "v1.5.0",
    Demo: StatusExpressionDemo,
  },
  {
    id: "onyx-hex-material",
    title: "Onyx Hex material",
    layer: "primitive",
    category: "Material",
    since: "v1.5.0",
    Demo: OnyxHexMaterialDemo,
    imports: ["nx", "hex", "raise", "elev", "NxKeyline"],
  },
  {
    id: "glass-surface",
    title: "GlassSurface",
    layer: "primitive",
    category: "Material",
    since: "v1.6.0",
    Demo: GlassSurfaceDemo,
  },
  // Chat blocks - K2 block renderers (chart / table / stat / citation / code)
  {
    id: "chart",
    title: "Chart",
    layer: "component",
    category: "Chat blocks",
    since: "v1.1.0",
    Demo: ChartDemo,
  },
  {
    id: "data-table",
    title: "DataTable",
    layer: "component",
    category: "Chat blocks",
    since: "v1.1.0",
    Demo: DataTableDemo,
  },
  {
    id: "stat",
    title: "Stat",
    layer: "component",
    category: "Chat blocks",
    since: "v1.1.0",
    Demo: StatDemo,
  },
  {
    id: "citation",
    title: "Citation",
    layer: "component",
    category: "Chat blocks",
    since: "v1.1.0",
    Demo: CitationDemo,
  },
  {
    id: "code-block",
    title: "CodeBlock",
    layer: "component",
    category: "Chat blocks",
    since: "v1.1.0",
    Demo: CodeBlockDemo,
  },
  {
    id: "artifact-block",
    title: "ArtifactBlock",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: ArtifactBlockDemo,
  },
  // Tier-1 rich chat blocks (docs/rich-blocks-catalog.md)
  {
    id: "callout",
    title: "Callout",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: CalloutDemo,
  },
  {
    id: "media",
    title: "Media",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: MediaDemo,
  },
  {
    id: "key-value",
    title: "KeyValue",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: KeyValueDemo,
  },
  {
    id: "carousel",
    title: "Carousel",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: CarouselDemo,
  },
  {
    id: "reasoning",
    title: "Reasoning",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: ReasoningDemo,
  },
  {
    id: "steps",
    title: "Steps",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: StepsDemo,
  },
  {
    id: "suggestions",
    title: "Suggestions",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: SuggestionsDemo,
  },
  {
    id: "interactive-blocks",
    title: "Form + Approval",
    layer: "component",
    category: "Chat blocks",
    since: "v1.2.0",
    Demo: InteractiveBlocksDemo,
    imports: ["Form", "Approval"],
  },
  // Post-process signal blocks (ais-agent-runtime#115 PostProcessSignals):
  // MemorySave landed first (v1.8.0/#194); its three siblings share one demo.
  {
    id: "memory-save",
    title: "MemorySave",
    layer: "component",
    category: "Chat blocks",
    since: "v1.8.0",
    Demo: MemorySaveDemo,
  },
  {
    id: "signal-blocks",
    title: "SignalBlocks",
    layer: "component",
    category: "Chat blocks",
    since: "v1.12.0",
    Demo: SignalBlocksDemo,
  },
  // Chat surface - the shared render seam both FE chats consume
  {
    id: "block-renderer",
    title: "BlockRenderer",
    layer: "component",
    category: "Chat surface",
    since: "v1.1.0",
    Demo: BlockRendererDemo,
  },
  {
    id: "chat-citations",
    title: "ChatCitations",
    layer: "component",
    category: "Chat surface",
    since: "v1.1.0",
    Demo: ChatCitationsDemo,
  },
  // Auth - full-page route scaffold + social sign-in (the ui-port wave)
  {
    id: "auth-shell",
    title: "AuthShell",
    layer: "component",
    category: "Auth",
    since: "v1.4.0",
    Demo: AuthShellDemo,
  },
  {
    id: "oauth-provider-buttons",
    title: "OAuthProviderButtons",
    layer: "component",
    category: "Auth",
    since: "v1.4.0",
    Demo: OAuthProviderButtonsDemo,
  },
  // Forms - composed inputs, pickers, and the rhf+zod field wrapper
  {
    id: "email-chip-input",
    title: "EmailChipInput",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: EmailChipInputDemo,
  },
  {
    id: "availability-input",
    title: "AvailabilityInput",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: AvailabilityInputDemo,
  },
  {
    id: "form-field",
    title: "FormField",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: FormFieldDemo,
  },
  {
    id: "member-picker",
    title: "MemberPicker",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: MemberPickerDemo,
  },
  {
    id: "color-picker",
    title: "ColorPicker",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: ColorPickerDemo,
  },
  {
    id: "image-uploader",
    title: "ImageUploader",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: ImageUploaderDemo,
  },
  {
    id: "source-ingestion",
    title: "SourceIngestion",
    layer: "component",
    category: "Forms",
    since: "v1.4.0",
    Demo: SourceIngestionDemo,
  },
  // Feedback - success / transition surfaces + the headless polling hook
  {
    id: "states",
    title: "Empty & loading states",
    layer: "component",
    category: "Feedback",
    since: "v1.20.0",
    Demo: ComponentStatesDemo,
    imports: [
      "Skeleton",
      "SkeletonParagraph",
      "EmptyState",
      "ErrorState",
      "TableSkeleton",
      "TableEmpty",
    ],
  },
  {
    id: "success-state",
    title: "SuccessState",
    layer: "component",
    category: "Feedback",
    since: "v1.4.0",
    Demo: SuccessStateDemo,
  },
  {
    id: "workspace-transition-overlay",
    title: "WorkspaceTransitionOverlay",
    layer: "component",
    category: "Feedback",
    since: "v1.4.0",
    Demo: WorkspaceTransitionOverlayDemo,
  },
  {
    id: "progressive-polling",
    title: "useProgressivePolling",
    layer: "component",
    category: "Feedback",
    since: "v1.4.0",
    Demo: ProgressivePollingDemo,
  },
  // Onboarding - guided tour + setup checklist
  {
    id: "aiko-tour",
    title: "AikoTour",
    layer: "component",
    category: "Onboarding",
    since: "v1.4.0",
    Demo: AikoTourDemo,
  },
  {
    id: "setup-checklist",
    title: "SetupChecklist",
    layer: "component",
    category: "Onboarding",
    since: "v1.4.0",
    Demo: SetupChecklistDemo,
  },
  // Navigation - listing toolbar + windowed pager
  {
    id: "filter-bar",
    title: "FilterBar",
    layer: "component",
    category: "Navigation",
    since: "v1.4.0",
    Demo: FilterBarDemo,
  },
  {
    id: "smart-pagination",
    title: "SmartPagination",
    layer: "component",
    category: "Navigation",
    since: "v1.4.0",
    Demo: SmartPaginationDemo,
  },
  // Utilities - permission gating
  {
    id: "permission-wrapper",
    title: "PermissionWrapper",
    layer: "component",
    category: "Utilities",
    since: "v1.4.0",
    Demo: PermissionWrapperDemo,
  },
  // Review & diff - comment composer + before/after diff row (the redline family)
  {
    id: "comment-popover",
    title: "CommentPopover",
    layer: "component",
    category: "Review & diff",
    since: "v1.5.0",
    Demo: CommentPopoverDemo,
  },
  {
    id: "diff-row",
    title: "DiffRow",
    layer: "component",
    category: "Review & diff",
    since: "v1.5.0",
    Demo: DiffRowDemo,
  },
  // Wave-1 (v1.6.0) — cards, inputs, chat overlays, and the converge motion piece
  {
    id: "card-grid",
    title: "CardGrid",
    layer: "component",
    category: "Cards",
    since: "v1.6.0",
    Demo: CardGridDemo,
  },
  {
    id: "experience-card-density",
    title: "ExperienceCard density",
    layer: "component",
    category: "Cards",
    since: "v1.6.0",
    Demo: ExperienceCardDensityDemo,
    imports: ["ExperienceCard"],
  },
  {
    id: "option-field",
    title: "OptionField",
    layer: "component",
    category: "Forms",
    since: "v1.6.0",
    Demo: OptionFieldDemo,
  },
  {
    id: "magic-edit-button",
    title: "MagicEditButton",
    layer: "component",
    category: "Inputs",
    since: "v1.6.0",
    Demo: MagicEditButtonDemo,
  },
  {
    id: "transcript-furniture",
    title: "Transcript furniture",
    layer: "component",
    category: "Chat surface",
    since: "v1.20.0",
    Demo: TranscriptFurnitureDemo,
    imports: [
      "DaySeparator",
      "MessageTimestamp",
      "CopyMessageButton",
      "MessageRegenerate",
      "ListeningWave",
      "ComposerHint",
    ],
  },
  {
    id: "message-feedback",
    title: "MessageFeedback",
    layer: "component",
    category: "Chat surface",
    since: "v1.6.0",
    Demo: MessageFeedbackDemo,
  },
  {
    id: "file-overlay",
    title: "FileOverlay",
    layer: "component",
    category: "Chat surface",
    since: "v1.6.0",
    Demo: FileOverlayDemo,
  },
  {
    id: "listening-overlay",
    title: "ListeningOverlay",
    layer: "component",
    category: "Chat surface",
    since: "v1.6.0",
    Demo: ListeningOverlayDemo,
  },
  {
    id: "rail-nav-button",
    title: "RailNavButton",
    layer: "component",
    category: "Navigation",
    since: "v1.6.0",
    Demo: RailNavButtonDemo,
  },
  // App-shell rail shell — composes the merged #144 RailNavButton as children.
  {
    id: "nav-rail",
    title: "NavRail",
    layer: "primitive",
    category: "Navigation",
    since: "v1.6.0",
    Demo: NavRailDemo,
  },
  {
    id: "vault-morph",
    title: "VaultMorph",
    layer: "component",
    category: "Motion & Effects",
    since: "v1.6.0",
    Demo: VaultMorphDemo,
  },
  // Onyx offset-key wave — clickable cards keep the notch
  {
    id: "card",
    title: "Card",
    layer: "primitive",
    category: "Surfaces",
    since: "v1.7.0",
    Demo: CardDemo,
  },
  {
    id: "collection-card",
    title: "CollectionCard",
    layer: "component",
    category: "Cards",
    since: "v1.7.0",
    Demo: CollectionCardDemo,
  },
  {
    id: "studio-card",
    title: "StudioCard",
    layer: "component",
    category: "Cards",
    since: "v1.7.0",
    Demo: StudioCardDemo,
  },
  {
    id: "tool-card",
    title: "ToolCard",
    layer: "component",
    category: "Cards",
    since: "v1.7.0",
    Demo: ToolCardDemo,
  },
  {
    id: "spotlight-card",
    title: "SpotlightCard",
    layer: "component",
    category: "Cards",
    since: "v1.7.0",
    Demo: SpotlightCardDemo,
  },
  {
    id: "depth-card",
    title: "DepthCard",
    layer: "component",
    category: "Cards",
    since: "v1.7.0",
    Demo: DepthCardDemo,
  },
  {
    id: "brand-tile",
    title: "BrandTile",
    layer: "component",
    category: "Cards",
    since: "v1.7.0",
    Demo: BrandTileDemo,
  },
];

/** The version whose components are still in review — gets the "New" tag. */
/** Newest shipped version — a component introduced here wears the "New" tag. */
export const LATEST_VERSION: Since = VERSIONS[VERSIONS.length - 1];

export interface NavCategory {
  category: string;
  entries: DemoEntry[];
}
export interface NavLayer {
  meta: LayerMeta;
  total: number;
  categories: NavCategory[];
}

/**
 * `DEMOS` reshaped into the layer → category → entries tree the sidebar
 * and main-content section headers both render from. Built once at module
 * load; preserves `DEMOS` order within each category.
 */
export const NAV: NavLayer[] = LAYERS.map((meta) => {
  const entries = DEMOS.filter((d) => d.layer === meta.id);
  const categories: NavCategory[] = [];
  for (const entry of entries) {
    let bucket = categories.find((c) => c.category === entry.category);
    if (!bucket) {
      bucket = { category: entry.category, entries: [] };
      categories.push(bucket);
    }
    bucket.entries.push(entry);
  }
  return { meta, total: entries.length, categories };
});

const ENTRY_BY_ID = new Map(DEMOS.map((d) => [d.id, d] as const));
const LAYER_BY_ID = new Map(LAYERS.map((l) => [l.id, l] as const));

/** Look up a demo's metadata by its section id (used by <Section>). */
export function entryForId(id: string): DemoEntry | undefined {
  return ENTRY_BY_ID.get(id);
}

/** Resolve a layer's display metadata. */
export function layerMetaFor(layer: Layer): LayerMeta {
  return LAYER_BY_ID.get(layer)!;
}

/**
 * Raw source of every demo file, surfaced in each section's "Code" tab.
 *
 * Vite's `import.meta.glob` with `query: "?raw"` inlines each file's text as a
 * string at build time — the idiomatic way to show component source in a docs
 * surface, with nothing to hand-copy and drift out of sync. `eager: true`
 * loads them synchronously so a lookup is a plain map read.
 */
const demoSourceModules = import.meta.glob("../demos/*.demo.tsx", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

/** Demo source keyed by file base ("Button" → source of Button.demo.tsx). */
const DEMO_SOURCE_BY_TITLE = new Map<string, string>(
  Object.entries(demoSourceModules).map(([path, source]) => [
    path
      .split("/")
      .pop()!
      .replace(/\.demo\.tsx$/, ""),
    source,
  ]),
);

/**
 * Raw source of a demo, looked up by its registry `title` — which equals the
 * demo file's base name for every entry (e.g. "AlertDialog" →
 * `AlertDialog.demo.tsx`). Returns `undefined` if no file matches, so callers
 * can fall back to a preview-only layout.
 */
export function demoSourceForTitle(title: string): string | undefined {
  return DEMO_SOURCE_BY_TITLE.get(title);
}

/**
 * Every demo flattened back into a single top-to-bottom order (layer →
 * category → entry), matching the sidebar. Backs the prev/next pager on each
 * component page, so "walk the whole library" is still one keystroke per step
 * now that the demos live on separate pages.
 */
export const ORDERED: DemoEntry[] = NAV.flatMap((layer) =>
  layer.categories.flatMap((c) => c.entries),
);

const INDEX_BY_ID = new Map(ORDERED.map((d, i) => [d.id, i] as const));

/**
 * The entries either side of `id` in that order. Both are `undefined` at the
 * ends — the pager renders a gap rather than wrapping around, so you can tell
 * you have reached the start or the end of the library.
 */
export function neighborsFor(id: string): {
  prev: DemoEntry | undefined;
  next: DemoEntry | undefined;
} {
  const i = INDEX_BY_ID.get(id);
  if (i === undefined) return { prev: undefined, next: undefined };
  return { prev: ORDERED[i - 1], next: ORDERED[i + 1] };
}

/** Count of components introduced in the newest version — shown on the overview. */
export const NEW_COUNT = DEMOS.filter((d) => d.since === LATEST_VERSION).length;

const IDENTIFIER = /^[A-Za-z_$][A-Za-z0-9_$]*$/;

/**
 * Export names for a demo's copyable import line.
 *
 * Uses the explicit `imports` list where the registry sets one, otherwise
 * derives it from the title — splitting on " + " so a paired demo
 * ("AnimatedSeparator + Collapse") yields both names. Returns an empty array
 * when neither produces valid identifiers, and the page then renders no import
 * line rather than one that would not compile.
 */
export function importNamesFor(entry: DemoEntry): readonly string[] {
  if (entry.imports) return entry.imports;
  const parts = entry.title.split(" + ").map((p) => p.trim());
  return parts.every((p) => IDENTIFIER.test(p)) ? parts : [];
}
